import { NON_LOCALIZED_PAGES, VALID_LOCALES_SET } from '@/constants';

/** Path without query and without leading locale segment (e.g. /es/headshot-generator -> /headshot-generator).
 * Uses case-insensitive locale match for consistency with buildCanonicalUrl.getCleanPath. */
function getCleanPath(path: string): string {
	const pathWithoutQuery = (path.split('?')[0] ?? '').trim();
	const withLeadingSlash = pathWithoutQuery.startsWith('/')
		? pathWithoutQuery
		: `/${pathWithoutQuery}`;
	const segments = withLeadingSlash.split('/').filter(Boolean);
	const firstSegment = segments[0];
	if (firstSegment && VALID_LOCALES_SET.has(firstSegment.toLowerCase())) {
		const rest = segments.slice(1).join('/');
		return rest ? `/${rest}` : '/';
	}
	return withLeadingSlash || '/';
}

export function isNonLocalizedPath(path: string): boolean {
	const cleanPath = getCleanPath(path);
	return NON_LOCALIZED_PAGES.some(
		page => cleanPath === page || cleanPath.startsWith(`${page}/`),
	);
}
